import React, { FunctionComponent } from 'react';
import {  TextField, Typography } from '@mui/material';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';

export const MeterPostcodeDialog: FunctionComponent<{
  open: boolean;
  onClose: () => void;
  searchPostcode: string;
  onPostcodeChange: (postcode: string) => void;
  onSearch: () => void;
}> = ({
  open,
  onClose,
  searchPostcode,
  onPostcodeChange,
  onSearch
}) => {
    return (
      <DialogWrapper
        open={open}
        onClose={onClose}
        title="Search for Meter"
        cancelHandler={onClose}
        submitHandler={onSearch}
        isSubmitting={false}
        disableSaveButton={!!searchPostcode.trim()}>
        <Typography sx={{ mb: 2 }}>
          Enter a postcode to search for available meters in that area
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Postcode"
          fullWidth
          variant="outlined"
          value={searchPostcode}
          onChange={(e) => onPostcodeChange(e.target.value)}
          placeholder="e.g., M46 0BJ"
        />
      </DialogWrapper>
    );
  };
